import { type ArticleCardProps } from '3-components/Cards/CardArticle/CardArticle';
import HTMLReactParser from 'html-react-parser';
import { resolveImageReferenceToImage } from '../../../../cms/resolvers/imageResolver';
import { resolveDate } from '../../../../cms/resolvers/dateResolver';
import { resolveMinRead } from '../../../../cms/resolvers/minReadResolver';
import type { AssetsListingQuery } from 'cms/cms';
import { resolveCategoriesToBadges } from 'cms/resolvers/badgeResolver';
import type { ImageProps } from '2-core-elements/Image/Image';
import type { BadgeProps } from '3-components/Chip/Chip';
// import { getApiHostname } from 'cms/constants';
export interface ArticleCardResolverSettings {
    minReadSuffix: string;
}

export type ArticlePages = {
    title?: string;
    summary?: string;
    type: string;
    topic?: string[];
    image?: {
        url: string;
        altText: string;
    };
    publishDate?: string;
    minutesToRead?: number;
    url?: string;
    category?: string[];
    speciality?: string;
    yearPublished?: string;
}

export const resolveArticlePagesToArticleCards = (items: ArticlePages[], settings: ArticleCardResolverSettings): ArticleCardProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { title, summary, type, image, publishDate, minutesToRead, url, speciality, yearPublished, category, topic } = item as NonNullable<typeof item>;
        const tags = [{ label: type, skin: type === 'Safety alert' ? 'error' : 'primary' }] as BadgeProps[];
        const img = resolveImageReferenceToImage(`${image?.url}`) as ImageProps;
        const date = resolveDate(publishDate);
        const minRead = resolveMinRead(minutesToRead, settings?.minReadSuffix ? settings.minReadSuffix : '');
        return {
            ...(url && { link: { href: url } }),
            title: title as string,
            ...(summary && { summary: HTMLReactParser(summary as string) }),
            tags,
            img,
            speciality,
            category,
            type,
            topic,
            date,
            minRead,
            yearPublished,
        };
    });
};

export type AssetPage = NonNullable<AssetsListingQuery['AssetPage']>;
export type AssetPageItems = NonNullable<AssetPage['items']>;

export const resolveAssetPagesToArticleCards = (items: AssetPageItems): ArticleCardProps[] => {
    return items.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { Title, PreviewTitle, PreviewDescription, PreviewImage, AssetTypeCategories, ContentLink } = item as NonNullable<typeof item>;
        const tags = resolveCategoriesToBadges(AssetTypeCategories);
        const img = resolveImageReferenceToImage(PreviewImage as string);

        return {
            ...(ContentLink?.Url && { link: { href: ContentLink.Url } }),
            title: PreviewTitle || Title as string,
            ...(PreviewDescription && { children: HTMLReactParser(PreviewDescription as string) }),
            tags,
            ...img as ImageProps,
        };
    });
};
